import React, { useState } from "react";
import search_icon from "../assets/icons/search_icon.png";

const SocialMediaFilter = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="mt-4 border h-screen rounded-md p-2">
      <div className="text-[16px] text-[#828282]">FILTERS</div>
      <p className="text-[#828282] text-[12px] mt-3">Search Category</p>
      <div className="flex border border-[#95C2FF] rounded-lg">
        <img
          src={search_icon}
          alt="search icon"
          className="w-5 object-contain mx-1"
        />
        <input
          type="text"
          placeholder="Search Category"
          className="text-[12px] w-full p-2 rounded-lg"
        />
      </div>
      <div className="mt-2">
        <div className="flex flex-col">
          <p className="text-[10px] mb-2">Types</p>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">New Collections</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Offers</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Festivals</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Exhibition</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Sample text 1</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Sample text 2</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Sample text 3</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Sample text 4</p>
          </label>
          <label className="flex mb-2">
            <input type="checkbox" />
            <p className="pl-2 text-[12px]">Sample text 5</p>
          </label>
        </div>
      </div>

      <div className="flex justify-between mt-2">
        <button className="p-2 text-[14px] font-bold text-[#2F80ED] border border-[#2F80ED] rounded-lg w-[49%]">
          Discard
        </button>
        <button className="p-2 text-[14px] font-bold bg-[#2F80ED] text-white rounded-lg w-[49%]">
          Apply
        </button>
      </div>
    </div>
  );
};

export default SocialMediaFilter;
